export interface ScoreRingProps {
  score: number;
  caption: string;
}

/**
 * 原型基元：`.score-ring`。
 * 环的渐变由 baseline.css 的 `.score-ring::after` 提供，这里只负责数值与文案。
 */
export function ScoreRing({ score, caption }: ScoreRingProps) {
  return (
    <div className="score-ring" role="img" aria-label={`${caption} ${score}`}>
      <div>
        <strong>{score}</strong>
        <span>{caption}</span>
      </div>
    </div>
  );
}
